const loaders = {
    '/signup': () => import('../pages/SignUp/SignUp'),
    '/resetpassword': () => import('../pages/SubmitResetPassword/SubmitResetPassword'),
    '/resendEmailVerification': () => import('../pages/ResendEmailVerification/ResendEmailVerification'),
    '/reset-password': () => import('../pages/NewPasswordReset/NewPasswordReset'),
    '/verify-email': () => import('../pages/VerifyEmail/VerifyEmail'),
    '/additems': () => import('../pages/AddCollectible/AddCollectible'),
    '/addcollectible': () => import('../pages/AddCollectible/AddCollectible'),
    '/addDiecast': () => import('../pages/AddCollectible/AddCollectible'),
    '/privacypolicy': () => import('../pages/PrivacyPolicy/PrivacyPolicy'),
    '/blog': () => import('../pages/BlogHomePage/BlogHomePage'),
    '/myHeroCardWishList': () => import('../pages/MyHeroCardWishList/MyHeroCardWishList'),
    '/nascardFantasy': () => import('../pages/TradingCardFantasyGame/TradingCardFantasyGame'),
};

const pending = new Map();

function resolvePath(pathname) {
    if (!pathname) return null;
    const clean = pathname.split('?')[0].split('#')[0];
    if (loaders[clean]) return clean;
    if (clean.startsWith('/blog/')) return '/blog';
    return null;
}

/** Prefetch a lazy route chunk by path (no-op for eager routes). */
export function prefetchRoute(pathname) {
    const key = resolvePath(pathname);
    if (!key) return Promise.resolve();
    if (pending.has(key)) return pending.get(key);
    const promise = loaders[key]().catch(() => {
        pending.delete(key);
    });
    pending.set(key, promise);
    return promise;
}

const IDLE_PREFETCH_PATHS = [
    '/additems',
];

/** Prefetch a few remaining lazy routes after first paint. */
export function scheduleIdlePrefetch() {
    const run = () => {
        IDLE_PREFETCH_PATHS.forEach((path) => prefetchRoute(path));
    };
    if (typeof window !== 'undefined' && typeof window.requestIdleCallback === 'function') {
        window.requestIdleCallback(run, { timeout: 4000 });
    } else {
        setTimeout(run, 2000);
    }
}

/** Props for Link / interactive elements that should prefetch on intent. */
export function prefetchHandlers(pathname) {
    return {
        onMouseEnter: () => prefetchRoute(pathname),
        onFocus: () => prefetchRoute(pathname),
        onPointerDown: () => prefetchRoute(pathname),
    };
}
